import Home from '@/components/common/Home.vue';

export const permitRoutes = {
  path: '/permit',
  component: Home,
  name: 'Permit',
  redirect: '/permit/role-page',
  meta: {
    title: 'Permit',
  },
  children: [
    {
      path: 'role-page',
      component: () => import('@/views/account/RoleRightsSetting.vue'),
      meta: {
        title: 'Role Setting',
      },
    },
    {
      path: 'user-aff-source',
      component: () => import('@/views/account/AccountAff.vue'),
      meta: {
        title: 'User-Aff Setting',
      },
    },
  ],
};
